var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<button class="btn btn-'+
((__t=( buttonType ))==null?'':__t)+
' '+
((__t=( caret ? 'dropdown-toggle' : '' ))==null?'':__t)+
' '+
((__t=( buttonClassName ))==null?'':__t)+
'"\n        id="'+
((__t=( id ))==null?'':__t)+
'"\n        type="button"\n        data-toggle="dropdown"\n        data-action="action-dropdown"\n        aria-haspopup="true"\n        aria-expanded="false">\n  '+
((__t=( title ))==null?'':__t)+
'\n</button>\n<div class="'+
((__t=( dropdownMenuClassName ))==null?'':__t)+
'" aria-labelledby='+
((__t=( id ))==null?'':__t)+
'>\n';
 _.each(items, function(item) { 
__p+='\n  ';
 if (item.role === 'separator') { 
__p+='\n    <div class="dropdown-divider '+
((__t=( item.className ))==null?'':__t)+
'"></div>\n  ';
 } else if (item.role === 'header') { 
__p+='\n    <h6 class="dropdown-header '+
((__t=( anyIcons ? 'dropdown-header-with-icon' : '' ))==null?'':__t)+
' '+
((__t=( item.className ))==null?'':__t)+
'">\n      '+
((__t=( item.title ))==null?'':__t)+
'\n    </h6>\n  ';
 } else if (item.role ==='item') { 
__p+='\n    <div data-mount="dropdown-item-tooltip-wrapper" '+
((__t=( typeof item.disabled === "string" ? 'data-toggle="tooltip" title="' + _.escape(item.disabled) +'"' : '' ))==null?'':__t)+
'>\n      <a\n        href="#"\n        data-mount="dropdown-item"\n        data-id="'+
((__t=( item.id ))==null?'':__t)+
'"\n        data-action="'+
((__t=( typeof item.action === "string" ? item.action : item.id ))==null?'':__t)+
'"\n        '+
((__t=( _.map(item.data, function(val, key) { return 'data-' + key + '="' + _.escape(val) + '"'; }).join(' ') ))==null?'':__t)+
'\n        class="dropdown-item '+
((__t=( anyIcons ? 'dropdown-item-with-icon' : '' ))==null?'':__t)+
' '+
((__t=( item.className ))==null?'':__t)+
' '+
((__t=( item.disabled ? 'disabled' : '' ))==null?'':__t)+
' "\n      >\n        '+
((__t=( item.title ))==null?'':__t)+
'\n        ';
 if (item.icon) { 
__p+='\n          <i class=\'material-icons dropdown-item-icon text-muted\'>'+
((__t=( item.icon ))==null?'':__t)+
'</i>\n        ';
 } 
__p+='\n      </a>\n    </div>\n  ';
 } else { logError('Misconfigured action item: ' + JSON.stringify(item) + ', on action dropdown ' + id); } 
__p+='\n';
 }) 
__p+='\n</div>\n';
}
return __p;
};
